import { toast } from "react-toastify";

const ProductImages = ({ images, setImages, errors, setErrors }) => {
  const MAX_FILE_SIZE = 12 * 1024 * 1024; // 12MB
  const ALLOWED_TYPES = [
    "image/jpeg",
    "image/png",
    "image/gif",
    "image/svg+xml",
  ];

  const handleImageChange = (index, e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file type
      if (!ALLOWED_TYPES.includes(file.type)) {
        toast.error("نوع الصورة غير مسموح به (JPG, PNG, JPEG, GIF, SVG)");
        e.target.value = "";
        return;
      }

      // Validate file size
      if (file.size > MAX_FILE_SIZE) {
        toast.error("حجم الصورة يجب ألا يزيد عن 12 ميجا");
        e.target.value = "";
        return;
      }

      const updatedImages = [...images];
      updatedImages[index] = {
        ...updatedImages[index],
        image_path: URL.createObjectURL(file),
        file: file,
      };
      setImages(updatedImages);
      setErrors((prev) => {
        const updatedErrors = { ...prev };
        delete updatedErrors["file"];
        return updatedErrors;
      });
    }
  };

  const addImage = () => {
    setImages([...images, { image_path: "", is_primary: 0 }]);
  };

  const removeImage = (index) => {
    if (index === 0) return; // prevent deleting first image
    const updatedImages = images.filter((_, i) => i !== index);
    setImages(updatedImages);
  };

  const setPrimaryImage = (index) => {
    const updatedImages = images.map((img, i) => ({
      ...img,
      is_primary: i === index ? 1 : 0,
    }));
    setImages(updatedImages);
  };
  console.log("errors", errors);
  return (
    <div className="product-images">
      <h6 className=" mb-2"> صور المنتج</h6>
      <div className="row">
        <div className="col-12">
          <div className="form-group">
            <div className="form-text text-muted mt-2">
              <div className="fs-5 fw-bold mb-2">تعليمات رفع الصور للمنتج</div>
              الحد الأقصى لحجم الصورة <strong>12MB</strong>.<br />
              الصيغ المسموح بها: <strong>JPG, PNG, JPEG, GIF, SVG</strong>.
            </div>
            {images.map((image, index) => (
              <div
                key={index}
                className="image-upload-item mb-3 p-3 border rounded"
              >
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => handleImageChange(index, e)}
                  className={`form-control ${errors?.[0]?.[0] ? "is-invalid" : ""}`}
                />

                {image.image_path && (
                  <div className="mt-2">
                    <img
                      src={image.image_path}
                      alt={`preview-${index}`}
                      style={{ maxWidth: "100px", marginRight: "10px" }}
                    />

                    <div className="btn-group mt-2">
                      <button
                        type="button"
                        className={`btn btn-sm ${image.is_primary ? "btn-primary" : "btn-outline-primary"}`}
                        onClick={() => setPrimaryImage(index)}
                      >
                        {image.is_primary ? "أساسية" : "تعيين كأساسية"}
                      </button>

                      {index !== 0 && (
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => removeImage(index)}
                        >
                          حذف
                        </button>
                      )}
                    </div>
                  </div>
                )}
              </div>
            ))}
            <button
              type="button"
              className="btn btn-outline-secondary mt-2"
              onClick={addImage}
            >
              + إضافة صورة أخرى
            </button>

            <div className="mt-3 text-muted">
              <small>
                • يمكنك إضافة صور متعددة للمنتج
                <br />• اختر صورة واحدة كصورة أساسية للمنتج
              </small>
            </div>
            {errors?.[0]?.[0] && (
              <span className="error">{errors?.[0]?.[0]}</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductImages;
